import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export default function SectionCard({ title, action, children, sx }) {
  return (
    <Paper sx={{ p: { xs: 2, md: 2.5 }, ...sx }}>
      {(title || action) && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
          {title ? <Typography variant="h3" component="h2">{title}</Typography> : <span />}
          {action || null}
        </Box>
      )}
      {children}
    </Paper>
  );
}
